import React from 'react'
import styled from 'styled-components'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const StyledButton = styled.button`
  padding: 11px 25px;
  color: #4f4f4f;
  font-size: 15px;
  text-transform: uppercase;
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, Helvetica,
    Segoe UI, Arial, sans-serif;
  font-weight: 600;
  letter-spacing: 1px;
  line-height: 20px;
  border-radius: 30px;
  background-color: transparent;
  min-width: 177px;
  border: 2px solid #4f4f4f;
  margin-right: 24px;
  display: inline-block;
  text-align: center;
  text-decoration: none;
  outline: none;
  max-height: 46px;
  :hover {
    background-color: #4f4f4f;
    cursor: pointer;
    color: rgb(246, 247, 248);
  }
  :active {
    opacity: 0.8;
  }
  @media (max-width: 768px) {
    min-width: 60vw;
    margin: 15px auto;
    display: block;
  }
`

const Rotate = styled.span`
  margin-left: 10px;
  display: inline-block;
  transform: rotate(45deg) scale(1.3) translateY(1px);
  font-weight: 500;
  margin-right: -4px;
  transition: transform 0.2s ease-out;
  ${StyledButton}:hover & {
    transform: rotate(45deg) scale(1.3) translate(1px, -1px);
  }
`

const Button = ({ children, link, onPressed, showArrow }) => (
  <CopyToClipboard
    text={'oscareriknilsson@gmail.com'}
    onCopy={() => onPressed()}
  >
    <StyledButton href={link}>
      {children}
      {showArrow ? <Rotate>↑</Rotate> : null}
    </StyledButton>
  </CopyToClipboard>
)

export default Button
